import React, { useRef, useState } from "react";
import { ArrowRight } from "lucide-react";

export function PromoStrip({ img, badge, title, subtitle, cta, target, accent = "from-cyan-400 to-teal-400", testid }) {
  const ref = useRef(null);
  const [shift, setShift] = useState({ x: 0, y: 0 });

  const onMove = (e) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    setShift({
      x: ((e.clientX - rect.left) / rect.width - 0.5) * 16,
      y: ((e.clientY - rect.top) / rect.height - 0.5) * 10,
    });
  };

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={() => setShift({ x: 0, y: 0 })}
      data-testid={testid}
      className="group relative overflow-hidden rounded-3xl border border-cyan-500/15"
    >
      <div className="relative min-h-[14rem] sm:h-72">
        <img
          src={img}
          alt={title}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out will-change-transform group-hover:scale-[1.04]"
          style={{ transform: `translate(${shift.x}px, ${shift.y}px) scale(1.06)` }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950/95 via-slate-950/60 to-slate-950/10" />
        <div className="relative flex min-h-[14rem] flex-col justify-center px-6 py-8 sm:h-full sm:px-12">
          <span className={`w-fit rounded-full bg-gradient-to-r ${accent} px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-widest text-slate-950 shadow-lg`}>
            {badge}
          </span>
          <h3 className="mt-4 max-w-md font-display text-2xl font-extrabold leading-tight text-white sm:text-3xl lg:text-4xl">{title}</h3>
          <p className="mt-2 max-w-sm text-sm text-slate-300 sm:text-base">{subtitle}</p>
          {cta && (
            <button
              data-testid={`${testid}-cta`}
              onClick={() => target && document.getElementById(target)?.scrollIntoView({ behavior: "smooth" })}
              className="mt-6 flex w-fit items-center gap-2 rounded-full bg-white px-7 py-3 text-sm font-bold text-slate-950 shadow-xl transition-transform duration-200 hover:scale-105 active:scale-95"
            >
              {cta} <ArrowRight className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
